import { render } from "./VocabularyExtractionResults.vue?vue&type=template&id=21ccf8d9&scoped=true"
import script from "./VocabularyExtractionResults.vue?vue&type=script&lang=js"
export * from "./VocabularyExtractionResults.vue?vue&type=script&lang=js"

import "./VocabularyExtractionResults.vue?vue&type=style&index=0&id=21ccf8d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ccf8d9"]])

export default __exports__